import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-26c37e27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "routeSubscription" }
const _hoisted_2 = { class: "routeSelectorWrapper" }
const _hoisted_3 = { id: "subscriptionRouteSearch" }
const _hoisted_4 = { class: "startDateWrapper dateItem" }
const _hoisted_5 = { for: "subscriptionStartDate" }
const _hoisted_6 = { class: "endDateWrapper dateItem" }
const _hoisted_7 = { for: "subscriptionEndDate" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "routeSubscriptionErrorMessage" }

import { computed, onMounted } from 'vue';
import { Skeletor } from 'vue-skeletor';
import { RouteDetail } from '../../types';
import { getSubscriptionEndDefault, getSubscriptionStartDefault } from '../../helpers/sms/determineSubscriptionDates';
import { DatePickerCalendar, RouteSearch } from '../../Molecules';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteSubscription',
  props: {
    mode: { default: 'edit' },
    startDate: {},
    endDate: {},
    routes: {},
    textCode: {},
    isLoading: { type: Boolean, default: false },
    routeError: { type: Boolean, default: false },
    rangeError: { type: Boolean, default: false }
  },
  emits: ["updateRoute", "updateStartDate", "updateEndDate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const routeDisabled = computed(() => props.mode === 'view' || props.mode === 'edit');
const startDateDisabled = computed(() => props.mode === 'view');
const endDateDisabled = computed(() => props.mode === 'view');

const subscriptionEndDate = getSubscriptionEndDefault();
const subscriptionStartDate = getSubscriptionStartDefault();

const initialStartDate = computed(() => (
  props.startDate ? props.startDate : subscriptionStartDate));

const initialEndDate = computed(() => (
  props.endDate ? props.endDate : subscriptionEndDate));

const errorToShow = computed(() => {
  if (props.routeError) {
    return 'You must select a route';
  }
  if (props.rangeError) {
    return 'The end date selected must be after the start date selected';
  }
  return '';
});

const handleStartDateSelected = (date: string) => {
  emit('updateStartDate', date);
};

const handleEndDateSelected = (date: string) => {
  emit('updateEndDate', date);
};

const handleRouteSelected = (textCode: string) => {
  emit('updateRoute', textCode);
};

onMounted(() => {
  emit('updateStartDate', initialStartDate.value);
  emit('updateEndDate', initialEndDate.value);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Route')), 1),
        _createVNode(_unref(RouteSearch), {
          "route-detail": _ctx.routes,
          "search-label-id": "subscriptionRouteSearch",
          "is-loading": _ctx.isLoading,
          "is-error": _ctx.routeError,
          disabled: routeDisabled.value,
          "selected-text-code": _ctx.textCode,
          onRouteSelected: handleRouteSelected
        }, null, 8, ["route-detail", "is-loading", "is-error", "disabled", "selected-text-code"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Start Date')), 1),
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(DatePickerCalendar), {
              key: 0,
              id: 'subscriptionStartDate',
              "date-format": 'dd/MM/yyyy',
              disabled: startDateDisabled.value,
              "initial-date": initialStartDate.value,
              "max-date": _unref(subscriptionEndDate),
              "min-date": _unref(subscriptionStartDate),
              "today-text": _ctx.$t('Today'),
              loading: _ctx.isLoading,
              "is-error": _ctx.rangeError,
              "onUpdate:selectedDate": handleStartDateSelected
            }, null, 8, ["disabled", "initial-date", "max-date", "min-date", "today-text", "loading", "is-error"]))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), {
              key: 1,
              height: "50"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('End Date')), 1),
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(DatePickerCalendar), {
              key: 0,
              id: 'subscriptionEndDate',
              "date-format": 'dd/MM/yyyy',
              disabled: endDateDisabled.value,
              "initial-date": initialEndDate.value,
              "max-date": _unref(subscriptionEndDate),
              "min-date": _unref(subscriptionStartDate),
              "today-text": _ctx.$t('Today'),
              loading: _ctx.isLoading,
              "is-error": _ctx.rangeError,
              "onUpdate:selectedDate": handleEndDateSelected
            }, null, 8, ["disabled", "initial-date", "max-date", "min-date", "today-text", "loading", "is-error"]))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), {
              key: 1,
              height: "50"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (errorToShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(errorToShow.value)), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})